import { createApp } from 'vue';
import ExampleComponent from '../components/ExampleComponent.vue';
import '../../scss/public.scss';

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('smart-content-sync-pro-public-app');

  if (el) {
    const app = createApp(ExampleComponent);
    app.mount(el);
  }
});
